<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-8 text-center">
      <h2>Limited Access</h2>
      <p class="mt-3">
        You haven't been added to a team yet. Contact your administrator to be
        assigned to a team.
      </p>
      <a routerLink="/home" class="btn btn-primary mt-3">Return to Home</a>
    </div>
  </div>
</div>
